import {
  NodeArticle,
  NodeBasicPage,
  NodeCrisisBanner,
  NodeDetailPage,
  NodeDocument,
  NodeEvent,
  NodeHomepage,
  NodeLandingPage,
  NodeOverviewPage,
  NodePartner,
  NodeProject,
  NodeVacancy,
} from '../implementations';

const mappers = {
  article: NodeArticle,
  basic_page: NodeBasicPage,
  detail_page: NodeDetailPage,
  crisis_banner: NodeCrisisBanner,
  document: NodeDocument,
  event: NodeEvent,
  homepage: NodeHomepage,
  landing_page: NodeLandingPage,
  overview_page: NodeOverviewPage,
  partner: NodePartner,
  project: NodeProject,
  vacancy: NodeVacancy,
};

export default mappers;
